import { router } from "expo-router";
import { observer } from "mobx-react";
import React from "react";
import { StyleSheet } from "react-native";
import { Layout } from "~/components/Layout";
import { Screen } from "~/components/Screen";
import { Spacer } from "~/components/Spacer";
import { ButtonV2 } from "~/components/V2/Button";
import { ListTabButton } from "~/components/V2/ListTabButton";
import { Container } from "~/components/V2/PageContainer";
import { View } from "~/components/V2/View";
import { useStore } from "~/mobx/utils/useStore";

const S = StyleSheet.create({
  logoutButton: { maxWidth: 110, width: "100%" },
  container: {
    paddingHorizontal: 0,
    paddingVertical: 0,
  },
});

export const SettingsScreen = observer(function SettingsScreen() {
  const store = useStore();

  const activeUser = store.authStore.activeUser;

  if (!activeUser) {
    return null;
  }

  return (
    <Screen withBottomInset withTopInset preventScroll>
      <Layout>
        <Container
          styleBottomView={S.container}
          title={intl.formatMessage({
            id: "Y294VV",
            defaultMessage: "Settings",
            description: "Title for the settings page",
          })}
        >
          <ListTabButton
            title={intl.formatMessage({
              id: "AoLGJ0",
              defaultMessage: "Contact details",
              description: "Title for the contact details section",
            })}
            onPress={() => {
              router.push("/(app)/settings/contact-details");
            }}
            borderTop={false}
          />
          <Spacer extraExtraLarge />
          {/* Logout button */}
          <View alignItemsCenter paddingHorizontal24>
            <ButtonV2
              medium
              style={S.logoutButton}
              secondary
              title={intl.formatMessage({
                id: "Xl2OHD",
                defaultMessage: "Logout",
                description: "Logout button",
              })}
              onPress={() => {
                store.authStore.logout("/(auth)/login");
              }}
            />
          </View>
        </Container>
      </Layout>
    </Screen>
  );
});
